import gsap from 'gsap';

$('body').on('initScripts pageTransitionComplete', function() {
    let animDuration = 0.5;

    if (prefersReducedMotion) {
        animDuration = 0;
    }

    const $body = $('body'),
        $menuShadow = $('.menu-overlay-shadow'),
        $menuBackground = $('.menu-overlay__background'),
        $menuContent = $('.menu-overlay__inner'),
        classToToggle = 'menu-open';

    $('[data-toggle*="menu"]').off('click');
    $('[data-toggle*="menu"]').on('click', function () {
        toggleMenuBar();
        $(this).blur();
    });

    // hide menu when clicked outside
    $('.menu-overlay-shadow').on('click', function () {
        hideMenuBar();
    });

    // hide menu on escape key press
    $(document).keyup(function(e) {
        if (e.key === "Escape") {
            hideMenuBar();
        }
    });

    $body.on('pageTransitionComplete', function () {
        $body.removeClass(classToToggle);
        $body.trigger('start-lenis');
        tl.progress(0).invalidate();
    });

    function toggleMenuBar() {
        if ($body.hasClass(classToToggle)) {
            hideMenuBar();
        } else {
            showMenuBar();
        }
    }

    function showMenuBar() {
        $body.trigger('stop-lenis');
        $body.addClass(classToToggle);

        tl.progress(0).invalidate();
        tl.play();
    }

    function hideMenuBar() {
        $body.removeClass(classToToggle);
        $body.trigger('start-lenis');

        tl.progress(1).reverse();
    }

    const tl = gsap.timeline({ paused: true });

    tl.to($menuShadow, {
        opacity: .5,
        duration: animDuration,
        ease: 'power2.inOut'
    });

    tl.to($menuBackground, {
        width: '100%',
        duration: animDuration,
        ease: 'power2.inOut'
    }, '<');

    tl.set($menuContent, { visibility: 'visible' });

    tl.to($menuContent, {
        opacity: 1,
        duration: animDuration/2,
        ease: 'power2.inOut'
    });
});
